/* RESPONSIBLE TEAM: team-reporting */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';

export default class TeamInboxPerformanceReportRoute extends IntercomRoute {
  @service customReportsService;

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  }
}
